export var PACKAGE_SOURCE = "components";
export var PACKAGE_VERSION = "3.0.0 (53ac2792)";
export var GIT_SHA = "53ac2792";
export var THEME = "default";
export var SYSTEM = "core";
export var ALWAYS_VISUAL_REFRESH = false;
export var INCLUDE_ONE_THEME = true;